const css = require('./style.css');
const $ = require('jquery');

const CHECKBOX = `.${css.checkbox}`;
const SELECT = `.${css.select}`;
const DROPDOWN = `.${css.dropdown}`;
const BUTTON = `.${css.button}`;
const IS_OPEN = css.isOpen;

class ChecklistSelect {
    constructor () {
        this.template = require('./template.hbs');
    }

    render () {
        let props = this.$context.props;
        return this.$context.getWatcherData().then((data) => Object.assign({}, data, props, { css }));
    }

    bind () {
        return {
            change: {
                [CHECKBOX]: this.changeCheckbox
            },
            click: {
                [SELECT]: this.toggleDropdown,
                [DROPDOWN]: this.stopPropagation,
                [BUTTON]: this.applyList
            }
        };
    }

    changeCheckbox (e) {
        const checkbox = $(e.currentTarget);
        const isChecked = checkbox.is(':checked');

        const key = checkbox.attr('cat-key');
        const id = checkbox.attr('id');

        const changeCheckboxSignal = this.$context.props.toggleBox;
        const toggleCheckboxes = this.$context.props.toggleAll;

        if (id == 'allOptions') {
            this.$context.signal(toggleCheckboxes, { isChecked });
        } else {
            this.$context.signal(changeCheckboxSignal, { key, isChecked });
        }
    }

    toggleDropdown (e) {
        e.stopPropagation();

        const checklistBody = $(e.currentTarget);
        const dropdown = checklistBody.next();
        const isOpen = !dropdown.hasClass(IS_OPEN);
        const changeDropdownSignal = this.$context.props.toggleDropdown;

        this.$context.signal(changeDropdownSignal, { isOpen });
    }

    applyList (e) {
        e.stopPropagation();

        const applyListSignal = this.$context.props.applyList;
        this.$context.signal(applyListSignal);
    }

    stopPropagation (e) {
        e.stopPropagation();
    }
}

module.exports = {
    constructor: ChecklistSelect
};



// WEBPACK FOOTER //
// ./packages/account-ui/check-list-select/index.js